<template>
  <v-main style="height: auto;">
    <v-container fluid class="primary lighten-5 pa-xs-2 pa-sm-2 pa-lg-10">
      <v-row align="center" justify="center" wrap>
        <v-col cols="12">
          <v-card
            color="white"
            rounded="lg"
            class="pa-xs-1 pa-sm-1 pa-md-1 pa-lg-5"
          >
            <v-img
              :src="topic.image"
              :alt="topic.title"
              :lazy-src="require('@/assets/img/logo.png')"
              max-height="250px"
            />
            <v-card-title
              class="d-flex d-flex-row align-start mb-xs-n4 mb-sm-n4 mb-md-n3 mb-lg-n11"
            >
              <p
                class="text-xs-h6 text-sm-h6 text-md-h5 text-lg-h4 font-weight-bold"
              >
                {{ topic.title }}
              </p>
              <v-chip
                color="primary"
                dark
                medium
                class="my-xs-0 my-sm-0 mmy-md-0 my-lg-1 mx-xs-0 mx-sm-0 mx-md-4 mx-lg-4"
                v-for="category in topic.categories"
                :key="category"
                >{{ category }}</v-chip
              >
            </v-card-title>
            <v-card-title>
              <p class="text-subtitle-1 font-weight-medium gray--text">
                posted {{ showElapsedTime }}
              </p>
            </v-card-title>
            <hr class="primary" />
            <v-card-text class="my-3">
              <span v-html="topic.body"></span>
            </v-card-text>
            <hr class="primary" />
            <v-card-text class="ma-0 text-subtitle-1 primary--text">
              <p>{{ comments.length }} comments</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Comments Container -->
      <v-row align="center" justify="center" wrap>
        <v-col cols="12">
          <v-card
            color="white"
            rounded="lg"
            class="mt-3 pa-xs-4 pa-sm-4 pa-md-1 pa-lg-5"
          >
            <!-- List of Comment -->
            <v-row align="center" justify="start">
              <v-col
                xs="11"
                sm="11"
                md="10"
                lg="10"
                xl="10"
                v-for="comment in comments"
                :key="comment.id"
                class="py-5"
              >
                <Comment v-if="!comment.isReported" :comment="comment" class="my-3" @toggleReport="openReportComment" />
              </v-col>
              <v-col
                cols="12"
                v-if="!comments.length"
                class="justify-center d-flex align-center"
              >
                <div
                  class="text-center rounded-lg text-h5 font-weight-semibold primary white--text pa-4 elevation-5"
                >
                  Start the discussion by leaving a
                  <span class="font-weight-bold">comment</span>!
                </div>
              </v-col>
            </v-row>

            <hr class="my-10" />

            <!-- New Comment Section -->
            <v-row align="center" justify="center" wrap class="mb-8">
              <!-- show new comment ui for logged in user -->
              <v-col cols="9" v-if="isUserLoggedIn">
                <p class="mb-4 text-h6">Post a New Comment</p>
                <NewComment :topicId="topic.id" />
              </v-col>
              <!-- Show a warning if the user is not logged in -->
              <v-col cols="12" v-else>
                <p class="text-center text-h6 font-weight-medium">
                  Please
                  <a @click="openAuth('login')" class="font-weight-bold"
                    >Login</a
                  >
                  or
                  <a @click="openAuth('register')" class="font-weight-bold"
                    >Register</a
                  >
                  to join the discussion!
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <AuthModal ref="authModal" />
    <ReportComment ref="reportComment" />
  </v-main>
</template>

<script>
import Comment from '@/components/ViewForum/Comment.vue'
import NewComment from '@/components/ViewForum/NewComment.vue'
import AuthModal from '@/components/AuthModal.vue'
import ReportComment from '@/components/ViewForum/ReportComment.vue'
import { formatToElapsedTime } from '@/utils/date'
import { ANALYTICS } from '@/configs/firebase'
import { logEvent } from 'firebase/analytics'

export default {
  name: 'ViewForum',
  components: { Comment, NewComment, ReportComment, AuthModal },
  async created() {
    const id = this.$route.params.id

    if (!id) {
      this.$router.replace('topic-not-found')
      return
    }

    let topics = this.$store.getters['cms/TOPICS']
    if (!topics.length) {
      await this.$store.dispatch('cms/POPULATE_FORUMS')
      topics = this.$store.getters['cms/TOPICS']
    }

    const topic = topics.find((t) => t.id === id)
    if (!topic) {
      this.$router.replace('/topic-not-found')
      return
    }

    this.topic = { ...topic }
    this.$store.commit('forums/SET_TOPIC', id)
    await this.$store.dispatch('comments/SUBSCRIBE_TO_COMMENTS', id)
    logEvent(ANALYTICS, 'viewed_forum_topic', {
      title: this.topic.title,
      id: this.topic.id
    })
  },
  async beforeDestroy() {
    await this.$store.dispatch('comments/UNSUBSCRIBE_TO_COMMENTS');
  },
  data: () => ({
    id: null,
    topic: {
      id: null,
      title: null,
      date: null,
      categories: null,
      image: null,
      body: null,
      comments: null
    }
  }),
  computed: {
    comments() {
      return this.$store.getters['comments/COMMENTS']
    },
    isUserLoggedIn() {
      return this.$store.getters['users/AUTH_USER']
    },
    totalComments() {
      return this.$store.getters['comments/TOTAL']
    },
    showElapsedTime() {
      return formatToElapsedTime(this.topic.date)
    }
  },
  methods: {
    openAuth(type) {
      this.$refs.authModal.open(type)
    },
    openReportComment(commentId) {
      this.$refs.reportComment.open(commentId)
    },
    showEditDelete(uid) {
      const user = this.$store.getters['users/USER']
      return this.isUserLoggedIn && user.uid === uid
    }
  }
}
</script>

<style></style>
